import { render, staticRenderFns } from "./SummaryReportPopover.vue?vue&type=template&id=36f648cc&scoped=true&"
import script from "./SummaryReportPopover.vue?vue&type=script&lang=js&"
export * from "./SummaryReportPopover.vue?vue&type=script&lang=js&"
import style0 from "./SummaryReportPopover.vue?vue&type=style&index=0&id=36f648cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f648cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f648cc')) {
      api.createRecord('36f648cc', component.options)
    } else {
      api.reload('36f648cc', component.options)
    }
    module.hot.accept("./SummaryReportPopover.vue?vue&type=template&id=36f648cc&scoped=true&", function () {
      api.rerender('36f648cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/StatusReports/SummaryReportPopover.vue"
export default component.exports